exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.app[data-v-2e795e3e] {\n  background: #EAF1F5;\n  transition: all ease-in-out 200px;\n}\n.app.blurry[data-v-2e795e3e] {\n    filter: blur(5px);\n}\n.app__progress-bar-background[data-v-2e795e3e] {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 5px;\n  left: 0;\n  z-index: 999;\n  background: rgba(140, 160, 179, 0.2);\n  filter: blur(5px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2e795e3e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 1199
// module chunks = 0